var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c("BjPage", {
        ref: "BjPage",
        attrs: {
          "query-params": _vm.queryParams,
          "col-span": _vm.colSpan,
          "label-width": "115px",
          "get-action": _vm.queryApi,
          serial: _vm.serial,
        },
        on: {
          showSetting: _vm.SortableTable.show,
          "header-dragend": _vm.SortableTable.handleHeaderDragend,
          "header-contextmenu": _vm.SortableTable.handleHeaderContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "baseForm",
            fn: function () {
              return [
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BjDialogListConfig.SKUname"),
                          prop: "skuName",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t("BjDialogListConfig.SKUname"),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuName,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuName", $$v)
                            },
                            expression: "queryParams.skuName",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t("BusinessStockSearch.table.skuCode"),
                          prop: "skuCode",
                        },
                      },
                      [
                        _c("BjInput", {
                          attrs: {
                            maxlength: _vm.MAX_LENGTH.DEFAULT,
                            placeholder: _vm.$t(
                              "BusinessStockChange.table.skuCode"
                            ),
                            clearable: "",
                          },
                          nativeOn: {
                            keyup: function ($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.handleQuery.apply(null, arguments)
                            },
                          },
                          model: {
                            value: _vm.queryParams.skuCode,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "skuCode", $$v)
                            },
                            expression: "queryParams.skuCode",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: _vm.colSpan } },
                  [
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: _vm.$t(
                            "BusinessStockSearch.header.exceedZero"
                          ),
                          prop: "exceedZero",
                        },
                      },
                      [
                        _c("BjSelectLov", {
                          attrs: {
                            placeholder: _vm.$t(
                              "BusinessStockSearch.header.exceedZero"
                            ),
                            "constant-key": "STATUS_YES_TRUE",
                          },
                          on: { change: _vm.handleQuery },
                          model: {
                            value: _vm.queryParams.exceedZero,
                            callback: function ($$v) {
                              _vm.$set(_vm.queryParams, "exceedZero", $$v)
                            },
                            expression: "queryParams.exceedZero",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                !_vm.$store.getters.cusId
                  ? _c(
                      "el-col",
                      { attrs: { span: _vm.colSpan } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("billingPage.CustomerName"),
                              prop: "clientCode",
                            },
                          },
                          [
                            _c("BjSelectLov", {
                              attrs: {
                                clearable: false,
                                "option-list": _vm.clientCodeList,
                                placeholder: _vm.$t("billingPage.CustomerName"),
                              },
                              on: { change: _vm.getUserCusid },
                              model: {
                                value: _vm.queryParams.clientCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryParams, "clientCode", $$v)
                                },
                                expression: "queryParams.clientCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            },
            proxy: true,
          },
          {
            key: "tableOperation",
            fn: function () {
              return [
                _c(
                  "el-col",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onExport()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("exportText")))]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission:BusinessStorageExportCBM",
                            arg: "BusinessStorageExportCBM",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.onExportCBM()
                          },
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessStockSearch.exportDetails.button")
                          )
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "tableColumn",
            fn: function () {
              return [
                _vm._l(_vm.dropCols, function (col, index) {
                  return [
                    col.prop !== "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            fixed: col.fixed || false,
                            align: "center",
                            "class-name": "item",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    false
                                      ? void 0
                                      : col.prop === "stockNum"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.stockNum.toFixed(0)
                                            )
                                          ),
                                        ])
                                      : col.prop === "preemptionNum"
                                      ? _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              (
                                                scope.row.preemptionNum +
                                                scope.row.lockNum
                                              ).toFixed(0)
                                            )
                                          ),
                                        ])
                                      : col.prop === "clientCode"
                                      ? _c("span", [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.clientCodeList.bjGet(
                                                  scope.row.skuCode &&
                                                    scope.row.skuCode
                                                      .split("-")
                                                      .slice(0, 1)
                                                      .join("")
                                                )
                                              ) +
                                              " "
                                          ),
                                        ])
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("timeFilters")(
                                                scope.row[col.prop],
                                                scope.row[col.prop]
                                              )
                                            )
                                          ),
                                        ]),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        })
                      : _vm._e(),
                    col.prop === "bjTableAction"
                      ? _c("el-table-column", {
                          key:
                            "col_" +
                            index +
                            "_" +
                            col.prop +
                            "_" +
                            (col.width || "auto"),
                          attrs: {
                            prop: col.prop,
                            label: col.label,
                            width: col.width || "auto",
                            align: "center",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("BusinessStockSearch.exportDetails.title"),
            visible: _vm.storageExportVisible,
            width: "700px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.storageExportVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "storageExportForm",
              attrs: {
                model: _vm.storageExportForm,
                rules: _vm.storageExportRules,
                "label-width": "160px",
              },
            },
            [
              !_vm.$store.getters.cusId
                ? _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("billingPage.CustomerName"),
                        prop: "clientCode",
                      },
                    },
                    [
                      _c("BjSelectLov", {
                        attrs: {
                          "option-list": _vm.clientCodeList,
                          clearable: false,
                          placeholder: _vm.$t("chooseText"),
                        },
                        model: {
                          value: _vm.storageExportForm.clientCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.storageExportForm, "clientCode", $$v)
                          },
                          expression: "storageExportForm.clientCode",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("billingPage.Date"), prop: "day" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      type: "date",
                      format: "dd/MM/yyyy",
                      "value-format": "yyyy-MM-dd",
                      placeholder: _vm.$t("chooseText"),
                    },
                    model: {
                      value: _vm.storageExportForm.day,
                      callback: function ($$v) {
                        _vm.$set(_vm.storageExportForm, "day", $$v)
                      },
                      expression: "storageExportForm.day",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t(
                      "BusinessStockSearch.exportDetails.detailType"
                    ),
                    prop: "category",
                  },
                },
                [
                  _c(
                    "el-radio-group",
                    {
                      model: {
                        value: _vm.storageExportForm.category,
                        callback: function ($$v) {
                          _vm.$set(_vm.storageExportForm, "category", $$v)
                        },
                        expression: "storageExportForm.category",
                      },
                    },
                    [
                      _c("el-radio", { attrs: { label: "CBM" } }, [
                        _vm._v("CBM"),
                      ]),
                      _c("el-radio", { attrs: { label: "Pallet" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.$t("BusinessStockSearch.exportDetails.pallet")
                          )
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c("span", { staticClass: "storage-export-hint" }, [
                  _vm._v(
                    _vm._s(_vm.$t("BusinessStockSearch.exportDetails.hint"))
                  ),
                ]),
              ]),
            ],
            1
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.storageExportVisible = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("cancelText")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmStorageExport },
                },
                [_vm._v(_vm._s(_vm.$t("exportText")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }